import React from "react";

import { Image } from "@chakra-ui/react";
import LogoImage from "../images/smuke_white.png";

export default function Header() {
    return (
        <Image src={LogoImage} alt="Logo" height="75px" mt={40} mb={5} mr="0" />
    );
}